import { Modal } from './Modal';

/** Confirmación dentro de la app, sin diálogos nativos del navegador. */
export function ConfirmModal({
  title,
  description,
  confirmLabel = 'Confirmar',
  tone = 'primary',
  busy = false,
  onClose,
  onConfirm,
}: {
  title: string;
  description?: string;
  confirmLabel?: string;
  tone?: 'primary' | 'danger';
  busy?: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
}) {
  return (
    <Modal
      title={title}
      eyebrow="Confirmación"
      onClose={busy ? () => undefined : onClose}
      footer={
        <>
          <button type="button" className="btn btn--outline" onClick={onClose} disabled={busy}>
            Cancelar
          </button>
          <button
            type="button"
            className={`btn ${tone === 'danger' ? 'btn--danger' : 'btn--primary'}`}
            onClick={() => void onConfirm()}
            disabled={busy}
          >
            {busy ? 'Procesando…' : confirmLabel}
          </button>
        </>
      }
    >
      <div className="modal-card__body">
        {description ? <p className="inline-note">{description}</p> : null}
      </div>
    </Modal>
  );
}
